import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0 16px 0 16px;
  background-color: #182231;
  position: relative;
  box-shadow: 0 12px 24px 0 #0F1927;
  border-radius: 4px 4px 0 0;
  z-index: 1;
`;

export default Container;
